import script from "./PieChart02.vue?vue&type=script&setup=true&lang=js"
export * from "./PieChart02.vue?vue&type=script&setup=true&lang=js"

import "./PieChart02.vue?vue&type=style&index=0&id=128bbf42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128bbf42"]])

export default __exports__